const radio = "_radio_1sdc9_57";
const disabled = "_disabled_1sdc9_72";
const styles = {
  radio,
  disabled
};
export {
  styles as default,
  disabled,
  radio
};
//# sourceMappingURL=Radio.module.scss.js.map
